import React, { useEffect } from 'react';

interface Props {
  value: string | number;
  changeValueFunc: (newValue: string | number) => void;
  title?: string;
  subtitle?: string;
  centered?: boolean;
  placeHolder?: string;
  isNumeric?: boolean;
  isEditable?: boolean;
  disabled?: boolean;
}

export const InputFieldWithTitles: React.FC<Props> = ({
  value,
  changeValueFunc,
  subtitle,
  title,
  centered = false,
  placeHolder = '',
  isNumeric = false,
  isEditable = true,
  disabled = false,
}) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    changeValueFunc(event.target.value);
  };

  useEffect(() => {
    changeValueFunc(value);
  }, [value]);

  return (
    <div className="flex flex-col ">
      {title && <p className={`text-lg text-black mb-1 ${centered && 'text-center'}`}>{title}</p>}
      {subtitle && <p className={`text-sm text-gray-600 mb-1 ${centered && 'text-center'}`}>{subtitle}</p>}
      <div className="w-full">
        {isEditable ? (
          <input
            type={isNumeric ? 'number' : 'text'}
            value={value}
            disabled={disabled}
            onChange={handleInputChange}
            className="text-base border-1 rounded  border-gray-450 focus:outline-blue-600 px-1 p-[3px] w-full"
            title="inputFiled"
            placeholder={placeHolder}
          />
        ) : value ? (
          <p className="truncate">{value}</p>
        ) : (
          <p className="text-gray-450 truncate">{placeHolder}</p>
        )}
      </div>
    </div>
  );
};
